(() => {
  const wrapper = document.getElementById('quiz-kit-app-wrapper');
  if (!wrapper || wrapper.dataset.sfQuizObserved) return;
  wrapper.dataset.sfQuizObserved = 'true';
  let observer;
  const load = () => {
    if (wrapper.dataset.sfQuizLoading) return;
    if (window.quizKitScriptLoaded && !window.sfHomeQuizDeferred) {
      observer?.disconnect();
      return;
    }
    window.sfHomeQuizDeferred = false;
    window.quizKitScriptLoaded = true;
    wrapper.dataset.sfQuizLoading = 'true';
    const styles = document.createElement('link');
    styles.rel = 'stylesheet';
    styles.href = 'https://d38jc50suw8dg3.cloudfront.net/current/static/main.min.css';
    document.head.appendChild(styles);
    const script = document.createElement('script');
    script.src = 'https://d38jc50suw8dg3.cloudfront.net/current/static/bundle.min.js';
    script.async = true;
    script.addEventListener('load', () => observer?.disconnect(), {once: true});
    script.addEventListener('error', () => {
      window.quizKitScriptLoaded = false;
      window.sfHomeQuizDeferred = true;
      script.remove();
      styles.remove();
      delete wrapper.dataset.sfQuizLoading;
    }, {once: true});
    document.head.appendChild(script);
  };
  wrapper.addEventListener('focusin', load);
  wrapper.addEventListener('pointerdown', load);
  if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
    load();
    return;
  }
  observer = new IntersectionObserver(entries => {
    if (entries.some(entry => entry.isIntersecting)) load();
  }, {rootMargin: '0px', threshold: 0.01});
  if (document.readyState === 'complete') observer.observe(wrapper);
  else window.addEventListener('load', () => observer.observe(wrapper), {once: true});
})();
